var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.hospitalId == 11)?_c('QuanFuPrint',{attrs:{"inquiryInfo":_vm.inquiryInfo,"_deptCode":_vm._deptCode,"appMobilePhone":_vm.appMobilePhone}}):_c('LinaOuPrint',{attrs:{"inquiryInfo":_vm.inquiryInfo,"_deptCode":_vm._deptCode,"appMobilePhone":_vm.appMobilePhone}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }